import React from 'react'
import '../Hero/Hero.css'
import { Link } from 'react-router-dom'
import HeroImg from '../../images/hero_image.png'
import SocialIcons from "../../components/SocialIcons/SocialIcons"

const PrivateHero = () => {


    
    return (
        <div className="hero-container">
            <div className="flexHero">
                <div className="left-container">
                    <h1 className="first-txt">The leading <span className="green-hlt"> community <br/> of digital natives </span> <br/> in Africa</h1>
                    <h1 className="second-txt">We are not just another community. We are a 500+ community of digital entrepreneurs, enthusiasts, beginners and veterans...</h1>
                    <Link to="/"><button className="joinus-btn">LEARN MORE</button></Link>
                </div>
                <div className="right-container">
                    <img className="heroImg" src={HeroImg} alt="hero"/>
                </div>
            </div>
            
            <SocialIcons color="#016b37" opacity="0.8" margin="hero-mrTop"/>
        </div>
    )
}

export default PrivateHero
